import { createSlice } from "@reduxjs/toolkit";
import { M24_CONFIG_DOC } from "libs/configs/constant";
import { logout } from "redux/modules/authSlice";
import { getSmartCompany } from "redux/modules/smartCompanySlice";

let initialState = { mode: null, projectID: "" };

export const m24SwitchModeSlice = createSlice({
  name: "m24SwitchMode",
  initialState: initialState,
  reducers: {
    resetAll: () => initialState,
    setMode(state, action) {
      state.mode = action.payload;

      if (state.mode !== M24_CONFIG_DOC.COM.CONDITION_TYPE) {
        state.projectID = "";
      }
    },
    setProjectId(state, action) {
      state.projectID = action.payload;
    },
  },
  extraReducers: (builder) => {
    // LoadingAdapter.applyAsyncBuilder(uploadSmartCompanyDoc, builder, ["data"]);
    builder.addCase(getSmartCompany.fulfilled, (state, action) => {
      const isChamber = action.payload.isChamber;
      const conditionType = action.payload.conditionType;

      state.mode = isChamber
        ? M24_CONFIG_DOC.COC.CONDITION_TYPE
        : conditionType || "PENDING";

      if (state.mode !== M24_CONFIG_DOC.COM.CONDITION_TYPE) {
        state.projectID = "";
      }
    });

    builder.addCase(logout, () => initialState);
  },
});

export const selectM24SwitchMode = (state) => state.m24SwitchMode.mode;
export const selectProjectID = (state) => state.m24SwitchMode.projectID;

export default m24SwitchModeSlice.reducer;
